import { QueryObserverOptions } from '@tanstack/react-query'
import qs from 'qs'

import config from '../../config'
import { buildGetQuery } from '../../util'

import { ISafetyCase, IGetRequestObject, EntityState } from '../../interfaces'

type QueryObject = {
  entityState: EntityState
}

const getSafetyCasesRequest = (params: undefined, queryObject: QueryObject | undefined): IGetRequestObject => {
  const queryString = qs.stringify(queryObject, { addQueryPrefix: true })

  return {
    method: 'get',
    url: `${config.baseUrl}/sms/SafetyCases${queryString}`,
  }
}

const useSafetyCasesQueryBase = buildGetQuery<undefined, QueryObject | undefined, ISafetyCase[] | undefined>({
  getRequest: getSafetyCasesRequest,
  getQueryKey: (params, queryObject) => ['safety-cases', queryObject?.entityState],
})

const useSafetyCasesQuery = (
  queryObject?: QueryObject | undefined,
  options?: QueryObserverOptions<ISafetyCase[] | undefined, Error>,
) => useSafetyCasesQueryBase(undefined, queryObject, options)

export default useSafetyCasesQuery
